import { supabase } from "@/integrations/supabase/client";
import { NavigateFunction } from "react-router-dom";

export const checkAdminAuthorization = async (
  navigate: NavigateFunction,
  onAuthStateChange?: (isAdmin: boolean) => void
) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();

    if (!user) {
      console.log('❌ [Auth] No user found');
      navigate('/authorize');
      return false;
    }

    const adminIds = [
      'caa1c553-6bfc-4770-9f81-dbf7e7a6b0ab',  // Original admin
      'b3fd6c2a-2151-4be3-98d0-a2fbec4c5c2a',   // Additional admin
      'f58db305-8918-4783-ac17-11a20e55b846',   // John@buyerson.co
      'a1108b57-b6df-44b3-828e-5615a6d251d4', // Emma
    ];

    const isAdmin = adminIds.includes(user.id);
    // console.log('👤 [Auth] User authorization check:', isAdmin);

    if (onAuthStateChange) {
      onAuthStateChange(isAdmin);
    }

    // if (!isAdmin) {
    //   navigate('/');
    // }

    return isAdmin;
  } catch (error) {
    console.error('❌ [Auth] Error checking authorization:', error);
    navigate('/');
    return false;
  }
};